const amount = value => Math.max(Number(value) || 0, 0)

export const allocateConciliationMovements = (pendingBalance, movements) => {
  let pending = amount(pendingBalance)
  const allocations = movements.map(movement => {
    const available = amount(movement.available)
    const assigned = Math.min(available, pending)
    pending = Math.max(pending - assigned, 0)
    return { ...movement, available, assigned, remaining: Math.max(available - assigned, 0) }
  })
  return {
    allocations,
    pending,
    assigned: allocations.reduce((sum, row) => sum + row.assigned, 0),
    remaining: allocations.reduce((sum, row) => sum + row.remaining, 0)
  }
}
